<template>
    <div class="PriceList">
    <!-- 头部 -->
    <headers :title="'报价单(客户)'"/>
     <!--  -->
     <div class="lc-container">
        <section class="g-flexview slide-page" id="mainPage">
            <section class="g-scrollview">
                <!-- 地址栏 -->
                <div class="addressOut">
                        <div class="addressContent">
                            <div class="namePhone">
                                <div class="name">{{OrderBaseInfo.CustomerName}}</div>
                                <div class="phone">{{OrderBaseInfo.CustomerPhone}}</div>
                                <div class="acreage" v-if="OrderBaseInfo.Acreage">{{OrderBaseInfo.Acreage}}㎡</div>
                            </div>
                            <div class="address">
                                {{OrderBaseInfo.CustomerAddress}}
                            </div>
                        </div>
                        <div class="addressRight">
                          
                        </div>
                </div>
                <!--  -->
                <div class="order-form" id='order-form' style="margin-bottom: 10px;">
					<!--  -->
                    <div v-for="(data,index) in ListOffer" :key="index">
                        <div class="order-content"  data-item=${id} :data-offerid="data.OfferId" :data-orderid="data.OrderId">
                        <div class="order-title">
                            <span>报价清单</span>
                        </div>
                        <div class="order-type "><div class='flex-left'>服务项目：</div><div class='flex-right'>{{data.ServiceName}}</div></div>
                        <div class="order-area"> <div class='flex-left'>数量：</div><div class='flex-right'>{{data.Qty}} <span>{{data.Unit}}</span></div></div>
                        <div class="order-price"><div class='flex-left'>单价：</div><div class='flex-right'>{{data.Price}}元</div></div>
                        <div class="order-totalprice"><div class='flex-left'>总价：</div><div class='flex-right'> {{data.Amount}}元</div></div>
                        <div class="order-tel"><div class='flex-left'> 现场联系人：</div><div class='flex-right'>{{data.CustomerName}}</div> </div>
                        <div class="order-tel"> <div class='flex-left'>现场联系人电话：</div><div class='flex-right'><a :href="'tel:' + data.CustomerPhone">{{data.CustomerPhone}}</a></div> </div>
                        <div class="order-remark"><div class="flex-left">预计施工日期：</div><div class="flex-right"><input type="date" :value="data.ReWorkDate" style="border: 0"></div></div>
                        <div class="order-remark"><div class='flex-left'>其他需求：</div><div class='flex-right'>{{data.OfferRemarks}}</div></div>
                    </div>
                    </div>
					<!--  -->
                </div>
                <div class="tabbtn">
                    <div class="backbtn" @click="back">
                        返回
                    </div>
                    <div class="enterbtn" v-if="isShowEnterbtn" @click="confirm">
                        同意报价
                    </div>
                </div>

            </section>
        </section>

    </div>
     <!--  -->


    </div>
</template>

<script>
import { Toast } from 'vant'
export default {
    data () {
        return {
           isShowEnterbtn:true,
           ListOffer:[],
           OrderBaseInfo:{}
        }
    },
    mounted() {
        this.$axios.get('/api/DjOrder/GetOfferList',{
            params: {
                 Id: this.$route.query.Id,
                 Flag: "OrderInfo"
            }
        }).then(res => {
            let data = res.data
            this.ListOffer = data.ListOffer
            this.ListOffer.forEach(i => {
                i.ReWorkDate = i.ReWorkDate.split(' ')[0]
            });
            this.OrderBaseInfo = data.OrderBaseInfo


            if (this.OrderBaseInfo.IsConfirmOffer == 1) {
               this.isShowEnterbtn = false
            }
        })
    },
    methods:{
        back () {
        this.$router.back()
        },
        confirm () {
          this.$axios.post('/api/DjOrder/SetAgreeOffer',{
             OrderId: this.$route.query.Id
            }).then(res => {
               let data = res.data
               if (data.type == 1) {
                    this.$router.replace('/orderlist')
                } else {
                    Toast.fail(data.message);
                } 
            })
        }
    }
}
</script>

<style scoped>
.lc-container {
    height: 100%;
}

.g-scrollview {
    margin-top: 40px;
}

.m-navbar {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 49;
    width: 100%;
}

.m-tab-bar {
    position: fixed;
    bottom: 0px;
    left: 0px;
    z-index: 49;
    width: 100%;
    height: 40px;
    background: #F5F5F5;
    border-top: 1px solid #ececec;
}

.order-form {
    min-height: 100%;

    margin: 0 auto;
    padding-bottom: 40px;
}

.order-content {
    background-color: #fff;
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    font-size: 16px;
    margin-bottom: 12px;

}

.order-title {
    height: 36px;
    width: 100%;
    border-bottom: 1px solid #f2f2f2;
    line-height: 36px;
    text-align: center;
    position: relative;

}

.order-title>.delitem {
    position: absolute;
    right: 16px;
    color: rgb(47, 142, 206);
}

.order-type,
.order-area,
.order-price,
.order-totalprice,
.order-tel,
.order-remark {
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 42px;
    border-bottom: 1px solid #ddd;
}

.order-area input,
.order-price input,
.order-totalprice input {
    width: 64px;
    border: 0;
    text-align: left;
    padding: 4px;
    border-radius: 4px;
    background-color: rgb(240, 240, 240);
    margin-right: 4px;
}

.order-tel input[type='text'] {
    width: 128px;
    border: 0;
    /* border-bottom: 1px solid #c5c5c5 !important; */
    text-align: center;
    padding: 4px;
    height: 28px;
    border-radius: 0px;
    margin-right: 4px;
}

.order-remark input {
    width: 70%;
    border: 0;
    /* border-bottom: 1px solid #c5c5c5 !important; */
    /* text-align: center; */
    padding: 4px;
    height: 28px;
    border-radius: 0px;
    margin-right: 4px;
}

.order-tel-checkbox {
    width: 10px;
    height: 10px;
    padding: 4px;

}

input[type="checkbox"] {
    -webkit-appearance: checkbox;
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    padding: 4px;
    zoom: 100%;
    margin-right: 4px;
}

.order-add {
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 42px;
    color: rgb(47, 142, 206);
    text-align: center;
}

.order-type>.order-type-options {
    border: 1px solid #c7c7c7;
    min-width: 64px;
    height: 26px;
    border-radius: 4px;
    text-align: center;
    text-align-last: center;
    font-size: 13px;
    padding: 0 8px;

}

.order-type-options>option {
    text-align: center;
    min-width: 64px;
    text-align-last: center;
    border: 1px solid #c7c7c7;
    border: 1px solid #ccc;
    font-size: 13px;
}

.tabbtn {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 40px;
    background-color: #fff;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #fff;
}

.savebtn {
    width: 33.3%;
    background-color: #f7bb4b;
}

.sendmes {
    width: 33.3%;
    background-color: #c21a1a;
}

.backbtn {
    width: 50%;
    background-color: #c21a1a;
    flex: 1;
}

.enterbtn {
    width: 50%;
    background-color: #009933;
    flex: 1;
}

.service-address {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 10px;
}

.order-remark>.flex-left {
    display: flex;
}

.order-remark>.flex-right {
    display: flex;
    flex: 1;
    width: 100%;
}

.flex-left {
    display: flex;
}

.flex-right {
    display: flex;
    flex: 1;
    width: 100%;
    align-items: center;
}
.addressOut{
    width: 100%;
    height: 80px;
    margin-top: 45px;
    background: #f7f4e4;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #6b6b6b;
}
.addressOut::before{
     content:'';
     position:absolute;
     top:0;
     width:100%;
     height:4px;
     background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAKBAMAAACOO0tGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURf///4u16Oxtbezz/J3B7NDh9vvd3fSmprjS8vGNje57e/jDw/7w8IQ3dnAAAABSSURBVCjPY2CAAG4l7GADVJ4hUBArEIXJJ2HXrw6TZ8auX7ABKs+zCLsBE2AGmGDXLwKT58SuX+sATIEjdgOcYfJF2A1Qg8lz4PCBwWgQUiMIAWCaOFG2MdFRAAAAAElFTkSuQmCC");
}
.addressOut::after{
     content:'';
     position:absolute;
     bottom:0;
     width:100%;
     height:4px;
     background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAKBAMAAACOO0tGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURf///4u16Oxtbezz/J3B7NDh9vvd3fSmprjS8vGNje57e/jDw/7w8IQ3dnAAAABSSURBVCjPY2CAAG4l7GADVJ4hUBArEIXJJ2HXrw6TZ8auX7ABKs+zCLsBE2AGmGDXLwKT58SuX+sATIEjdgOcYfJF2A1Qg8lz4PCBwWgQUiMIAWCaOFG2MdFRAAAAAElFTkSuQmCC");
}
.addressContent{
    height: 100%;
      width: 90%;
      margin-left: -2px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 5px;
}
.namePhone{
    display: flex;
    margin-bottom: 12px;
}
.name{
    margin-right: 12px;
}
.phone{
    margin-right: 64px;
}
          
</style>



// WEBPACK FOOTER //
// src/pages/OrderList/PriceList.vue